class TabbedCarousel {
  constructor(sectionId, modalId) {
    this.container = document.getElementById(sectionId);
    this.modal = document.getElementById(modalId);
    
    if (!this.container || !this.modal) return;
    
    this.initTabs();
    this.initSliderNav();
    this.initCardGallery();
    this.initModal();
    this.initTriggers();
    this.initToastListener();
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
  }

  showToast(message) {
    const toast = this.container.querySelector('.tab-carousel__toast');
    if (!toast) return;
    toast.innerText = message;
    toast.classList.add('show');
    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  }

  initToastListener() {
    if (window.PUB_SUB_EVENTS && window.subscribe) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
         if (event.source === 'product-form') {
           this.showToast("Added to Cart!");
           setTimeout(() => { this.modal.classList.remove('open'); }, 500);
         }
      });
    }
  }

  initTabs() {
    const tabs = this.container.querySelectorAll('.tab-carousel__tab-btn');
    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
         this.container.querySelectorAll('.tab-carousel__tab-btn').forEach(b => b.classList.remove('active'));
         this.container.querySelectorAll('.tab-carousel__content').forEach(c => c.classList.remove('active'));
         
         btn.classList.add('active');
         const targetId = btn.dataset.target;
         document.getElementById(targetId).classList.add('active');
      });
    });
  }

  initSliderNav() {
    const prev = this.container.querySelector('.prev-slide');
    const next = this.container.querySelector('.next-slide');
    
    if(prev && next) {
      prev.addEventListener('click', () => this.scrollActiveSlider(-1));
      next.addEventListener('click', () => this.scrollActiveSlider(1));
    }
  }

  scrollActiveSlider(dir) {
    const activeTab = this.container.querySelector('.tab-carousel__content.active');
    if(activeTab) {
      const slider = activeTab.querySelector('.tab-carousel__slider');
      slider.scrollBy({ left: 300 * dir, behavior: 'smooth' });
    }
  }

  initCardGallery() {
    this.container.querySelectorAll('.tab-carousel__img-nav').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation(); // Stop QV trigger
        const wrapper = btn.closest('.tab-carousel__gallery');
        const track = wrapper.querySelector('.tab-carousel__gallery-track');
        const dir = btn.classList.contains('left') ? -1 : 1;
        
        const cardWidth = track.clientWidth;
        const maxScroll = track.scrollWidth - track.clientWidth;
        
        if (dir === 1 && (track.scrollLeft + 10) >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (dir === -1 && track.scrollLeft <= 10) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardWidth * dir, behavior: 'smooth' });
        }
      });
    });
  }

  initTriggers() {
    this.container.querySelectorAll('[data-qv-trigger]').forEach(trigger => {
       trigger.addEventListener('click', () => {
         if(trigger.hasAttribute('disabled')) return;
         const id = trigger.dataset.id;
         this.openModal(id);
       });
    });
  }

  initModal() {
    this.modal.querySelectorAll('.qv-trigger-close').forEach(el => {
      el.addEventListener('click', () => this.modal.classList.remove('open'));
    });

    this.modal.querySelectorAll('.qv-arrow').forEach(arrow => {
      arrow.addEventListener('click', () => {
         const track = this.modal.querySelector('.qv-slider-track');
         const dir = parseInt(arrow.dataset.dir);
         track.scrollBy({ left: track.clientWidth * dir, behavior: 'smooth' });
      });
    });
  }

  openModal(uniqueId) {
     const script = document.getElementById(`data-${uniqueId}`);
     if(!script) return;
     const data = JSON.parse(script.textContent);

     this.modal.querySelector('.qv-title').innerText = data.title;
     this.modal.querySelector('.qv-price').innerText = this.formatMoney(data.price);
     this.modal.querySelector('.qv-desc').innerText = data.description;
     this.modal.querySelector('.qv-link').href = data.url;
     
     this.modal.querySelector('.qv-variant-id').value = data.id;

     const stockMsg = this.modal.querySelector('.qv-stock-msg');
     if(data.is_low_stock) {
       stockMsg.innerText = `🔥 Only ${data.inventory_qty} left!`;
       stockMsg.style.display = 'block';
     } else {
       stockMsg.style.display = 'none';
     }

     const btn = this.modal.querySelector('.qv-add-btn');
     const span = btn.querySelector('span');
     
     if(data.available) {
       btn.disabled = false;
       if(span) span.innerText = "Add to Cart";
     } else {
       btn.disabled = true;
       if(span) span.innerText = "Sold Out";
     }

     const track = this.modal.querySelector('.qv-slider-track');
     let imgs = '';
     if(data.images && data.images.length > 0) {
        data.images.forEach(src => {
           imgs += `<img src="${src}" class="qv-slide">`;
        });
     } else {
        imgs = '<div style="width:100%;height:100%;background:#eee;"></div>';
     }
     track.innerHTML = imgs;

     this.modal.classList.add('open');
  }
}

// Make accessible globally
window.TabbedCarousel = TabbedCarousel;